import $ from 'jquery';
import _ from 'underscore';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { segmentPlugin } from '@bingads-webui-campaign/projection-grid-segment';
import { setSegmentationData } from '@bingads-webui-campaign-react/competition-core';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { segmentationType, adinsightSegmentationTypeEnum } from '@bingads-webui-campaign/segmentation-utilities';
import { inlineDownloadWithoutFilterstatePlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { clientSideDownload, MAX_NUMBER_OF_ACCOUNT, TOO_MUCH_DATA_TO_DOWNLOAD_ERROR } from '@bingads-webui-campaign/auction-insight-common';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { getPGridColumnResizePlugin } from '@bingads-webui-campaign/projection-grid-column-resize-helper';
import { GENERAL_INSIGHTS_FEATURE_NAMES } from '@bingads-webui-campaign/competition-auction-insight-preferences';

import { pillControlPlugin } from './pill-control-plugin';
import { getColumnChooserConfig } from '../general-insights-grid-columns';
import { campaignTypeSwitcher } from './campaign-type-switch-plugin';

const { getSegType, setSegType } = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const instrumentation = globalContext.require('campaignui/feature/instrumentation/index');
const appState = globalContext.require('component/state/index');
const appConfig = globalContext.require('component/config/index');
const permissions = appConfig.get('Permissions');
const DownloadView = globalContext.require('campaignui/feature/griddownload/view/baseDownload');


const segmentationTypesForSummaryMenu = [
  segmentationType.DayOfWeek,
  segmentationType.HourOfDay,
  segmentationType.Device,
];
const segmentationTypesForOverTimeMenu = [
  segmentationType.Day,
  segmentationType.Week,
  segmentationType.Month,
  segmentationType.Quarter,
  segmentationType.Year,
  segmentationType.Device,
];

export function getGeneralInsightsPlugins({
  campaignType,
  selectedCampaignType,
  refreshChart,
  onCampaignTypeChange,
  preferenceServiceLegacy,
  auctionInsightPerfMarker,
  i18n,
  scope,
  getView,
  preferenceConfig,
  showAlertHandler,
  p$daterange,
}) {
  const columnChooserConfig = getColumnChooserConfig({ campaignType, scope });
  columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';

  let noDataText = i18n.getString('AuctionInsights_GridNoDataDetail');
  if (scope.levelAt === 'Customer') {
    if (scope.accountsInfo.error === TOO_MUCH_DATA_TO_DOWNLOAD_ERROR) {
      noDataText = i18n.getString('AuctionInsights_GridNoDataDetail_TooMuchDataError');
    } else if (scope.accountsInfo.totalCount > MAX_NUMBER_OF_ACCOUNT) {
      noDataText = i18n.getString('AuctionInsights_GridNoDataDetail_ExceedMaxNum', { maxNumberOfAccount: MAX_NUMBER_OF_ACCOUNT });
    }
  }

  return _.compact([{
    // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
    plugin: perfMarkerPlugin,
    config: {
      appConfig,
      marker: auctionInsightPerfMarker,
    },
  },
  {
    plugin: a11yPlugin,
    config: { i18n },
  },
  {
    plugin: columnChooserPlugin,
    config: columnChooserConfig,
  }, {
    plugin: segmentPlugin,
    config: {
      cellTemplates: {
        DisplayDomain: 'default',
      },
      i18n,
      permissions,
      cultureShortDatePattern: 'M/d/yyyy',
      state: appState,
      setSegType(name, segType) {
        setSegmentationData({
          gridName: name,
          segType,
          setSegType,
          preferencesService: preferenceServiceLegacy,
        });
        _.defer(refreshChart);
      },
      isOdataActionSource: false,
      edm: null,
      segmentationTypes: [], // use pill control to dynamic set allowed segmentation types
      instrumentation,
      getSegType,
    },
  }, {
    plugin: placeholderPlugin,
    config: {
      container: '.auction-insight-page-container .grid-noresult',
      filteredEmptyText: i18n.getString('Grid_NoFilteredRecords'),
      text: noDataText,
    },
  }, {
    plugin: dateFilterPlugin,
    config: {
      state: appState,
      addDateChangeListener: _.noop,
      p$daterange,
    },
  }, {
    plugin: pillControlPlugin,
    config: {
      i18n,
      pillControlType:
        _.chain(preferenceConfig)
          .result('query').result('query')
          .result('PillControlType')
          .value(),
      segmentationTypesCollection: [
        segmentationTypesForOverTimeMenu,
        segmentationTypesForSummaryMenu,
      ],
    },
  }, {
    plugin: inlineDownloadWithoutFilterstatePlugin,
    config: {
      DownloadView,
      isAvailable: true,
      i18n,
      entity: 'AuctionInsight',
      customDownloadService: (format, segmentType) => {
        clientSideDownload(format, segmentType, getView(), scope, appState, i18n, showAlertHandler);
      },
      downloadFormats: ['Csv'],
      segmentationTypes: adinsightSegmentationTypeEnum,
    },
  }, {
    plugin: uiBlockerPlugin,
    config: { el: $('.auction-insight-page-container') },
  }, {
    plugin: campaignTypeSwitcher,
    config: {
      campaignType,
      selectedCampaignType,
      onCampaignTypeChange,
      i18n,
    },
  },
  getPGridColumnResizePlugin({
    gridName: GENERAL_INSIGHTS_FEATURE_NAMES[campaignType],
    preferenceService: preferenceServiceLegacy,
    permissions,
  }),
  ]);
}
